/* eslint-disable */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { createGenericSlice } from '../lib'
import { getOne, ResponseType } from '../../services/endpoints/test'

export type TestState = {
  status?: string //should be set to ok
}

const getStatus = createAsyncThunk<ResponseType>('test/getStatus', async () => {
  return await getOne()
})

const initialState: TestState & any = {
  loading: false,
  status: 'unknown',
  error: null,
}

export const testSlice = createGenericSlice({
  name: 'test',
  initialState,
  reducers: {},
  thunkAdapters: [],
  extraReducers: builder => {
    return builder?.addCase(getStatus.fulfilled, (state, action) => {
      state.loading = false
      state.error = null
      state.status = action.payload.status
    })
  },
})
